import {
  Box,
  Grid,
  Slider,
  Typography
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { updateThemeConfig } from "../../actions";
import ColorComponent from "./ColorConponent";
import RadioComponent from "./RadioComponent";
import SelectComponent from "./SelectComponent";
import BackgroundComponent from "./BackgroundComponent";
import TextComponent from "./TextComponent";
import Select2Component from "./Select2Component";
import { formatName } from "./ThemeConfig";

function DesignComponent() {
  const { theme_config} = useSelector(
    (state) => ({
      theme_config: state.theme_config
    })
  );
  const dispatch = useDispatch();
  return (
    <div
      id="config-theme-group"
      className="card-body p-2"
    >
      {window.ThemeConfig.map((field) => {
        field.value = theme_config[field.name]
        if(field.name === "logo" ||field.name === "hide_header" || field.name === "show_powered_btn" || field.name === "show_welcome_screen"|| field.name === "intro_content"  || field.name === "position_pagination"){
            return <></>
        }
        switch (field.type_render) {
          case "color":
            return <ColorComponent field={field} />;
          case "select":
            return (
                <SelectComponent field={field} />
            );
          case "radio":
            return (
                <RadioComponent field={field} />
            );
          case "select2":
            return (<Select2Component field={field} />);
          case "textarea":
            return (
              <Box sx={{padding:'15px 0 !important'}}>
                <Grid container spacing={2}>
                    <Grid item sx={12}>
                      <Typography>{formatName(field.name)}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <textarea
                        class="form-control col-12"
                        name={field.name}
                        onChange={(e) => {
                          dispatch(updateThemeConfig(field.name, e.target.value));
                        }}
                        rows="4"
                      >
                        {field.value}
                      </textarea>
                    </Grid>
                </Grid>
              </Box>
            );

          case "range":
            const marks = [
              {
                value: -100,
                label: "-100",
              },
              {
                value: 0,
                label: "0",
              },
              {
                value: 100,
                label: "100",
              },
            ];
            return (
            <Box sx={{padding:'15px 0 !important'}}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>{formatName(field.name)}</Typography>
                </Grid>
                <Grid item xs={12}>
                   <Box
                      sx={{padding:'0px 15px !important'}}
                    >
                      <Slider
                        name={field.name}
                        onChange={(event, newValue) => {
                          dispatch(updateThemeConfig(field.name, newValue));
                        }}
                        defaultValue={field.value}
                        valueLabelDisplay="auto"
                        max={100}
                        min={-100}
                        marks={marks}
                        step={5}
                        color="secondary"
                      />
                    </Box>
                </Grid>
              </Grid> 
            </Box>
            );

          case "image":
            return (
              <BackgroundComponent field={field}/>
            );

          default:
            return (
              <TextComponent field={field}/>
            );
        }
      })}
    </div>
  );
}

export default DesignComponent;
